// import React, {Component} from 'react';
import React from 'react';

// class Title extends Component {
//     render() {
//       return (
//         
//       )
//     }
//   }

// export default Title



const Title = (props) => {
  return (
    <div>
      <h1>{props.title}</h1>
    </div>
  );
}

export default Title;
